
import { repListingTemplate } from "../templates";
var RepFinder = Backbone.View.extend({
    el: '#rep-finder-app',
    events: {
        // 'change select.country-select' : 'selectCountry',
        // 'change select.state-select' : 'selectState',
        'click button.country-select' : 'selectCountry',
        'click button.state-select' : 'selectState'
        
    },
    initialize: function(){
        _.bindAll( this, 'render', 'resetReps', 'addRep', 'addCountry', 'selectCountry', 'showReps', 'selectState', 'addStateOption' );
    },
    render: function(){
        var countries = this.collection.pluck( 'country' );

        var uniqCountries = _.uniq( countries );
        _.each( uniqCountries, this.addCountry );

        this.changeCountry( 'USA' );
    },
    addCountry: function( country ){
        if ( typeof country !== 'undefined' ) {
            // this.$('select.country-select').append( '<option value="'+country+'">'+country+'</option>' );
            this.$('.country-select-list').append( '<button class="country-select dropdown-item" data-value="'+country+'" type="button">'+country+'</button>' );
            
        }
    },
    addStateOption: function( state ){
        if ( typeof state !== 'undefined' ) {
            // this.$('select.state-select').append( '<option value="'+state+'">'+state+'</option>' );
            this.$('.state-select-list').append( '<button class="state-select dropdown-item" data-value="'+state+'" type="button">'+state+'</button>' );
            
            
        }
    },
    selectState: function( e ){ 
        
        var state = e.currentTarget.dataset.value;
        this.model.set({ 'state' : state });
        this.$('.state-button').text(state);
        this.showReps();
    },
    selectCountry: function(e){
        var newCountry = e.currentTarget.dataset.value;
        this.changeCountry( newCountry );
    },
    changeCountry: function(newCountry){
        this.$('.country-button').text(newCountry);
        this.resetReps();

        this.model.set({ 'country' : newCountry });
        this.model.set({ 'state' : null });

        // alert( newCountry );

        var countryReps = this.collection.where({ 'country': newCountry });
        // console.log( countryReps );
        var states = _.map( countryReps, function( rep ){ return rep.get('state'); } );
        var countryStates = _.uniq( states );

        // sort this countryStates
        countryStates.sort();

        this.$('.state-select-list').html('');
        this.$('.state-button').text('Select Your Province or State');
       
        // this.$('select.state-select').html('<option value="">Select Your Province or State</option>');
        if ( countryStates.length > 1 ) {
            this.$('.state-selector').removeClass( 'd-none' );
            _.each( countryStates, this.addStateOption );
        } else {
            this.$('.state-selector').addClass( 'd-none' );
            this.showReps();
        }
    },
    resetReps: function(){
        this.$('.rep-output').html('');
    },
    showReps: function(){
        var search = this.model.toJSON();
        if ( _.isNull( search.state ) ) {
            search.state = 'All';
        }
        var reps = this.collection.where( search );
        var heading = search.state === 'All' || _.isNull( search.state ) ? search.country: search.state;
        this.$('.rep-output').html('<h2>'+heading+'</h2>')

        _.each( reps, this.addRep );
    },
    addRep: function( rep ){
        var output = repListingTemplate( rep.toJSON() );
        this.$('.rep-output').append( output );
    }
});
export {RepFinder};